import * as React from 'react';
import { useDVSNumber } from '@doordash/lib-dvs-client/lib/react';
import { DV2_NAMES, dv2DefaultsNonBoolean } from '../DV2';
import Quiz from './Quiz/Quiz';
import QuizV2 from './QuizV2/QuizV2';
export var ProductOptionsRouter = function () {
    var productOptionsVersion = useDVSNumber(DV2_NAMES.ddfwSelfServeProductOptionsVersion, dv2DefaultsNonBoolean.ddfwSelfServeProductOptionsVersion);
    if (productOptionsVersion === 4) {
        // Display Quiz V2
        return React.createElement(QuizV2, null);
    }
    return React.createElement(Quiz, null);
};
export default ProductOptionsRouter;
